import React from "react";

export const LikeIcon = ({
  width = 20,
  height = 20,
  color = "currentColor",
}: {
  width?: number;
  height?: number;
  color?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 22V11l-5 0v11h5zm2-11l0 11h4.09c.55 0 1.07-.26 1.41-.7l3.58-4.69c.26-.34.42-.77.42-1.21V13c0-1.1-.9-2-2-2h-4.09l.61-2.93.02-.11c0-.41-.17-.79-.44-1.06L11.17 5.5 6.59 10.09c-.37.37-.59.88-.59 1.41V20z" />
  </svg>
);
